// extracted by mini-css-extract-plugin
export var container = "_mg-0";
export var dotAnimation = "_mg-2";
export var dotsLoading = "_mg-1";